import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import useAuthStore from "components/core/Auth/useAuthStore";
import useVendorStore from "components/core/HomePage/useVendorStore";
import { PageContainer, ContentArea, HeaderBar, OtpTitle, OtpSubTitle, OtpWrapper, ErrorText, TimerContainer, TimerText, ResendWrapper, ResendNoteText, ResendButton, BottomActionWrapper, PrimaryButton, otpInputStyles, MainContent, IllustrationWrapper, TextWrapper, DeletedTitle, DeletedSubTitle, SplashContainer, SplashLogoText, SplashSubText } from "./styles";

const DeleteAccountOtp = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(30);
  const [showResend, setShowResend] = useState(false);
  const [localError, setLocalError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [showTransition, setShowTransition] = useState(false);

  const sendDeleteAccountOtp = useAuthStore((state) => state.sendDeleteAccountOtp);
  const verifyDeleteAccountOtp = useAuthStore((state) => state.verifyDeleteAccountOtp);
  const sendDeleteOtpStatus = useAuthStore((state) => state.loginDetails.sendDeleteOtp);
  const verifyDeleteOtpStatus = useAuthStore((state) => state.loginDetails.verifyDeleteOtp);
  const error = useAuthStore((state) => state.error);

  const phone_no = useVendorStore((state) => state.sellerProfile?.phone_number) || "";
  const formattedNumber = phone_no ? `+91 ${phone_no}` : "";

  useEffect(() => {
    if (!sendDeleteOtpStatus.begin && !sendDeleteOtpStatus.done) {
      sendDeleteAccountOtp({ phone_no });
    }
  }, []);

  useEffect(() => {
    if (sendDeleteOtpStatus.done) {
      setLocalError("");
      setTimer(30);
      setShowResend(false);
    }
    if (sendDeleteOtpStatus.fail) {
      setLocalError(error?.message || "Unable to send OTP. Please try again.");
    }
  }, [sendDeleteOtpStatus, error]);

  useEffect(() => {
    if (verifyDeleteOtpStatus.done) {
      setShowSuccess(true);
    }
    if (verifyDeleteOtpStatus.fail) {
      setLocalError(error?.message || "Incorrect OTP. Please enter again.");
    }
  }, [verifyDeleteOtpStatus, error]);

  useEffect(() => {
    if (timer <= 0) {
      setShowResend(true);
      return;
    }
    const interval = setTimeout(() => setTimer(timer - 1), 1000);
    return () => clearTimeout(interval);
  }, [timer]);

  const handleResend = () => {
    if (!showResend) return;
    setOtp("");
    setLocalError("");
    sendDeleteAccountOtp({ phone_no });
    setShowResend(false);
    setTimer(30);
  };

  const handleVerify = () => {
    setLocalError("");
    verifyDeleteAccountOtp({ otp });
  };

  const handleOkay = () => {
    setShowTransition(true);
    setTimeout(() => {
      if (window.logoutChannelMessageHandler) {
        window.logoutChannelMessageHandler.postMessage("logout");
      } else {
        window.location.replace("/login");
      }
    }, 2000);
  };

  if (showTransition) {
    return (
      <SplashContainer>
        <SplashLogoText>Hyperpure</SplashLogoText>
        <SplashSubText>BY ZOMATO</SplashSubText>
      </SplashContainer>
    );
  }

  if (showSuccess) {
    return (
      <PageContainer>
        <ContentArea>
          <MainContent>
            <IllustrationWrapper>
              <img src="/logos/iphone.svg" alt="Account deleted" />
            </IllustrationWrapper>
            <TextWrapper>
              <DeletedTitle>We are sorry to see you go</DeletedTitle>
              <DeletedSubTitle>
                Your account has been deleted. For any help please reach out to support team.
              </DeletedSubTitle>
            </TextWrapper>
          </MainContent>
          <BottomActionWrapper>
            <PrimaryButton onClick={handleOkay}>Okay</PrimaryButton>
          </BottomActionWrapper>
        </ContentArea>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <ContentArea $gap="24px">
        <HeaderBar $mb="8px" onClick={() => navigate(-1)}>
          <img src="/logos/back_logo.svg" alt="Back" width={20} height={20} />
          <span>Delete account</span>
        </HeaderBar>

        <div>
          <OtpTitle>Enter verification code</OtpTitle>
          <OtpSubTitle>
            6 digit OTP has been sent to {formattedNumber || "your registered number"}
          </OtpSubTitle>
        </div>

        <OtpWrapper>
          <OtpInput
            inputType="tel"
            value={otp}
            onChange={setOtp}
            numInputs={6}
            separator={<span style={{ width: "10px" }} />}
            renderInput={(inputProps) => <input {...inputProps} />}
            shouldAutoFocus
            inputStyle={otpInputStyles}
          />
        </OtpWrapper>

        {localError ? <ErrorText>{localError}</ErrorText> : null}

        <TimerContainer>
          <TimerText>
            {timer > 0 ? `00:${timer < 10 ? `0${timer}` : timer}` : "00:00"}
          </TimerText>
          <ResendWrapper>
            <ResendNoteText>Didn't receive the code?</ResendNoteText>
            <ResendButton type="button" disabled={!showResend} onClick={handleResend}>
              Resend now
            </ResendButton>
          </ResendWrapper>
        </TimerContainer>

        <BottomActionWrapper>
          <PrimaryButton
            type="button"
            disabled={otp.length < 6 || verifyDeleteOtpStatus.begin}
            onClick={handleVerify}
          >
            Delete account
          </PrimaryButton>
        </BottomActionWrapper>
      </ContentArea>
    </PageContainer>
  );
};

export default DeleteAccountOtp;
